import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
    ViewChild
} from "@angular/core";
import {ItemTax, OrderItem} from "../../../../objects/orders/orderItem";
import {NgForm} from "@angular/forms";
import {EnumUtil} from "../../../../common/utils/EnumUtil";
import {Product} from "../../../../objects/products/product";
import {Cookie} from "ng2-cookies/ng2-cookies";
import {ConfigService} from "../../../../services/configService";
import {BaseResponse} from "../../../../objects/common/baseResponse";
import {SearchResponse} from "../../../../objects/responses/searchResponse";
import {Order} from "../../../../objects/orders/order";
import {Country} from "../../../../objects/management/locationManagement/Country";
import {Guid} from "../../../../common/helpers/guidHelper";
import {CanadianCurrencyCode} from "../../../../objects/currencyExchange/canadianCurrencyCode";
import {Duty, DutyType} from "../../../../objects/calculator/duty";
import {ProductService} from "../../../../services/productService";
import {TariffSource} from "../../../../objects/tariffs/tariffSource";
import {PdaType} from "../../../../objects/orders/PdaType";
import {Tuple} from "../../../../objects/common/Tuple";
import {CalculatorType} from "../../../../objects/orders/calculatorType";
import {Location} from "../../../../objects/management/locationManagement/location";
import {ProductSearchRequest} from "../../../../objects/requests/productSearchRequest";
import {Subscription} from "rxjs/Subscription";
import {CalculatorService} from "../../../../services/calculator/calculatorService";
import {RequestType} from "../../../../objects/products/requestType";
import {AccordionPanelComponent} from "ngx-bootstrap";
import {CalculatorHelper} from "../../../../common/helpers/calculatorHelper";
import {OrderItemOptions} from "../../../../objects/orders/orderItemOptions";
import {OrderOptions} from "../../../../objects/orders/orderOptions";
import {ProductSearchType} from "../../../../objects/products/productSearchType";
import {HScodeHelper} from "../../../../common/helpers/HScodeHelper";
import {TaxType} from "../../../../objects/orders/taxType";
import {TaxService} from "../../../../services/calculator/tax.service";

export interface Setect2Data {
    id: number;
    text: string;
}

/**
 * Created by vlad.p on 8/21/2017.
 */

declare var $: any;

@Component({
    selector: "calculator-accordion",
    templateUrl: "calculator-accordion.component.html",
    moduleId: module.id.toString()
})
export class CalculatorAccordion implements AfterViewInit, OnDestroy {

    @Input()
    public index: number;

    @Input()
    public orderItem: OrderItem;

    @Input()
    public productForm: NgForm;

    @Input()
    public currentProduct: OrderItem;

    @Input()
    public order: Order;

    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[];

    @Input()
    public defaultState: boolean;

    @Input()
    public disableChanges: boolean;

    @Input()
    public isQuickQuote: boolean = false;

    public get isUsService(): boolean {
        if (!this.order || !this.order.Flag)
            return false;

        return this.order.Flag.hasFlag(OrderOptions.IsUsService);
    }

    @Input()
    public isPublic: boolean = false;

    // @Input()
    public get isVehicle(): boolean {
        return this.calculatorHelper.isVehicle(this.order);
    }

    public calculatorHelper = CalculatorHelper;

    public enumUtil = EnumUtil;
    public string = String;
    public calculatorType = CalculatorType;
    public tariffSource = TariffSource;
    public orderOptions = OrderOptions;
    public dutyType = DutyType;
    public OrderOptions = OrderOptions;

    public manualHsCode: string;
    public isTarifLoading: boolean = false;
    public select2ProductId: string = `productSelect-${Guid.newGuid()}`;
    public select2ProductData: any = null;

    public select2ManufacturerId: string = `manufacturer-${Guid.newGuid()}`;
    public select2PdaId: string = `pda-${Guid.newGuid()}`;
    public select2CurrencyId: string = `pda-${Guid.newGuid()}`;
    public select2CurrencyData: any = null;

    public pdaEnum = PdaType;

    public polarizationDuty: Duty;
    private subscription: Subscription;
    private subscriptionIsVehicle: Subscription;

    public manufacturer: string = '';

    public isPassVehicle: boolean = false;
    public IsTrucksVal: boolean = false;

    public isAC: boolean = false;
    public isVehicleParts: boolean = false;
    public isTrailerOnly: boolean = false;

    private pagerConfig: any = {
        itemsPerPage: 10,
        currentPage: 0,
        totalItems: 1
    };

    public isProductNameHidden: boolean = true;

    get usedEquipmentExamp() {
        return this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(OrderItemOptions.UsedEquipment);
    }

    set usedEquipmentExamp(val: boolean) {
        if (val) {
            this.orderItem.Flags |= OrderItemOptions.UsedEquipment;
        } else {
            this.orderItem.Flags &= ~OrderItemOptions.UsedEquipment;
        }
    }

    public get greenLevy() {
        let tax = this.orderItem.Taxes.find(x => x.TaxType == TaxType.GreenLevy);

        if (!tax) {
            tax = new ItemTax({
                TaxType: TaxType.GreenLevy
            });
            this.orderItem.Taxes.push(tax);
        }

        return tax;
    }

    public get greenLevyValue() {
        let tax = this.orderItem.Taxes.find(x => x.TaxType == TaxType.GreenLevy);

        return !tax ? null : tax.Value;
    }

    @ViewChild('accordionForm')
    public accordionForm: NgForm;

    @ViewChild('prodInput') public productSelect: ElementRef;

    @ViewChild('group')
    private accordion: AccordionPanelComponent;
    private initialized: boolean = false;

    @Output()
    public onItemRemoved: EventEmitter<OrderItem> = new EventEmitter();

    public getClass(): any {
        if (!this.initialized)
            return "panel-default";
        if (this.accordion.isOpen)
            return "accordion-open";
        if (!this.accordionForm.valid && !this.disableChanges)
            return 'accordion-error';
        else
            return "";
    }

    public greenLevyResult: Array<Setect2Data> = [
            {
                id: 0,
                text: "0-13 liters"
            },
            {
                id: 1,
                text: "13-14 liters"
            },
            {
                id: 2,
                    text: "14-15 liters"
            },
            {
                id: 3,
                    text: "15-16 liters"
            },
            {
                id: 4,
                    text: "16 or more liters"
            }];

    public $greenLevyElement: any;
    public $greenLevySelect: any;

    constructor(private configService: ConfigService,
                public productService: ProductService,
                private calculatorService: CalculatorService,
                private ChangeDetectorRef: ChangeDetectorRef,
                public taxService: TaxService) {
    }

    public checkForm(): boolean {
        this.accordionForm.onSubmit(null);

        return this.accordionForm.valid;
    }

    public ngAfterViewInit(): void {

        this.$greenLevyElement = $(`#${this.select2ProductId}_greenLevy`);

        this.subscription = this.calculatorService.subscribe(location => {
            if (!location)
                return;

            //if (location.Type == 2) {
                this.handleHsChange(true);
            //}

            if (CalculatorHelper.isUsaShipmentFrom(this.order) && CalculatorHelper.isCanadianVehicleCalculator(this.order)) {
                setTimeout(() => {
                    this.initGreenLevySelect();
                }, 150);
            }
        });

        this.subscriptionIsVehicle = this.calculatorService.subscribeIsVeh(isVehicle => {
            if (this.select2ProductData) {
                this.select2ProductData.destroy();

                let t = $(`#${this.select2ProductId}`);

                t.off('select2:select');
                t.off('select2:unselect');
                t.off('select2:close');
                t.off('select2:open');

                setTimeout(() => {
                    this.initProductSelect();
                });
            }

            setTimeout(() => {
                this.initYearSelect();
            });

            if (CalculatorHelper.isUsaShipmentFrom(this.order) && CalculatorHelper.isCanadianVehicleCalculator(this.order)) {
                setTimeout(() => {
                    this.initGreenLevySelect();
                }, 150);
            }

            this.handleHsChange(true);
        });


        setTimeout(() => {
            this.initialized = true;
            this.initProductSelect();
            this.initManufacturerSelect();
            this.initPdaSelect();
            this.initCurrencySelect();
            this.initYearSelect();
            this.initGreenLevySelect();
        });

        if (CalculatorHelper.isCanadianVehicleCalculator(this.order) && this.orderItem.Flags != null) {
            this.isAC = this.orderItem.Flags.hasFlag(OrderItemOptions.IsAC);
            this.isVehicleParts = this.orderItem.Flags.hasFlag(OrderItemOptions.IsVehicleParts);
            this.isTrailerOnly = this.orderItem.Flags.hasFlag(OrderItemOptions.isTrailerOnly);
            //this.lessOrEqualFifteenYears = this.orderItem.Flags.hasFlag(OrderItemOptions.IsLessOrEqualFifteenYrs);
        }
    }

    public ngOnDestroy() {
        if (this.subscription)
            this.subscription.unsubscribe();

        if (this.subscriptionIsVehicle)
            this.subscriptionIsVehicle.unsubscribe();
    }

    public initProductSelect(): void {
        let self = this;
        let $element = $(`#${self.select2ProductId}`);

        $element.select2({
            width: '100%',
            data: [],
            selectOnClose: true,
            placeholder: self.isVehicle ? 'Enter vehicle make and model' : 'Type and select product (minimum two words)',
            language: {
                noResults: function () {
                    return "Sorry, nothing matches, please source the HS/Tariff code manually and enter it into HS Code input field.";
                },
                inputTooShort: () => {
                    return this.isVehicle ? $('<span>please enter 2 or more characters</span><br><span>*note, search result will contain most used tariffs</span>')
                        : "please enter 2 or more characters";
                },
            },
            ajax: {
                dataType: 'json',
                delay: 500,
                transport: (params: any, success: any, failure: any): any => {
                    let request = new ProductSearchRequest({
                        Query: params.data.term,
                        CustomerId: self.order.Customer && self.order.Customer.Id && !self.isPublic ? self.order.Customer.Id : '',
                        Skip: self.pagerConfig.currentPage++ * self.pagerConfig.itemsPerPage,
                        Top: self.pagerConfig.itemsPerPage,
                        Source: self.getSearchType(),
                        RequestType: RequestType.ProductsAndTariffs,
                        SearchType: self.getSearchTypeByQuery(params.data.term)
                    });

                    this.productService.search(request).then((response: any) => {

                        if ((!response || !response.Data || response.Data.TotalCount == 0) && (this.order.Flag && this.order.Flag.hasFlag(OrderOptions.IsVehicle))) {
                            request.Query = "87%";
                            request.SearchType = 2;

                            this.productService.search(request).then((response: any) => success(response));
                        }
                        else
                            success(response);
                    }).catch((_: any) => failure());
                },
                processResults: function (data: BaseResponse<SearchResponse<Product>>, params: any) {
                    self.pagerConfig.totalItems = data.Data.TotalCount;

                    let results: any[] = data.Data.Items.map(function (product) {
                        return {
                            id: product.Id,
                            text: product.Name,
                            item: product,
                            updateTariff: true,
                            isSelect: true
                        }
                    });

                    return {
                        results: results,
                        pagination: {
                            more: self.pagerConfig.currentPage * self.pagerConfig.itemsPerPage < self.pagerConfig.totalItems
                        }
                    };
                },
            },
            templateResult: function formatState(state: any) {
                if (!state.id) {
                    self.pagerConfig.currentPage = 0;
                    return state.text;
                }

                return $(
                    (self.getSearchType() == null ? '<span> Tariff Country: ' + (state.item.Source == TariffSource.Usa ? 'USA' : 'Canada') + '</span><br>' : '') +
                    (state.item.Name ? ('<span>' + state.item.Name + '</span><br>') : '') +
                    (state.item.Description ? ('<span>' + state.item.Description + '</span><br>') : '') +
                    '<span>' + state.item.HsCode + '</span><br>' +
                    '<span>' + self.calculatorHelper.getProductTariff(state.item, self.orderItem, self.order, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25) + '</span>'
                );
            },
            minimumInputLength: 2
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            if (!selectedData || !selectedData[0])
                return;

            selectedData[0] = e.params.data;

            if (selectedData[0].item == null) {
                return;
            }

            if (CalculatorHelper.isUsedEquipment(selectedData[0].item) && ((self.orderItem.Product == null || !self.orderItem.Product.Name)
                || !CalculatorHelper.isUsedEquipment(self.orderItem.Product))) {
                self.orderItem.Flags |= OrderItemOptions.UsedEquipment;
            }

            if (!CalculatorHelper.isUsedEquipment(selectedData[0].item)) {
                self.orderItem.Flags &= ~OrderItemOptions.UsedEquipment;
            }
            let tempName = "";

            if (selectedData[0].isSelect && selectedData[0].item.Name && selectedData[0].item.Description) {
                tempName = selectedData[0].item.Name;
            }
            else
                tempName = self.orderItem.Product.Name;//Get typed name from select 2, see on close select handler

            if (!tempName)
                tempName = "";

            self.orderItem.Product = selectedData[0].item;

            if (self.orderItem.Product.HsCode || !self.manualHsCode)
                self.manualHsCode = self.orderItem.Product.HsCode;//TODO ??

            if (tempName || (self.orderItem.Product.Name && !self.orderItem.Product.Description)) {
                let tempDescription = self.orderItem.Product.Name; //Save Name as description
                self.orderItem.Product.Name = tempName; // override name(description) to name that was typed

                if (self.orderItem.Product.Id && !self.orderItem.Product.Description)// set description to real description
                    self.orderItem.Product.Description = tempDescription;
            }

            if (selectedData[0].updateTariff)
                CalculatorHelper.getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, self.order.Flag && self.order.Flag.hasFlag(OrderOptions.IsVehicle), self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);

            if (!self.orderItem.Product.Name && !self.orderItem.Product.Description) {
                self.isProductNameHidden = true;
                return;
            }

            self.select2ProductData.$selection.hide();
            self.isProductNameHidden = false;
        }).on('select2:close', function (e: any) {
            self.pagerConfig.currentPage = 0;
            let select = $(this).data("select2");

            if (self.select2ProductData && self.select2ProductData.results && self.select2ProductData.results.lastParams
                && self.select2ProductData.results.lastParams.term) {

                self.orderItem.Product.Name = select.results.lastParams.term;
                select.results.lastParams.term = "";

                self.select2ProductData.$selection.hide();
                self.isProductNameHidden = false;
            }

        }).on('select2:unselect', function (e: any) {
            self.clearProduct();
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        this.select2ProductData = $element.data("select2");

        if (this.isUsService) {
            $element.prop("disabled", true);
        }

        if (!self.orderItem.Product || (!self.orderItem.Product.Name && !self.orderItem.Product.Description && !self.orderItem.Product.HsCode)) {
            this.isProductNameHidden = true;
            return;
        }

        setTimeout(() => {
            if (this.select2ProductData) {
                if (this.orderItem.Product != null && this.orderItem.Product.Source != null && this.order.CalculatorType != +this.orderItem.Product.Source) {
                    this.handleHsChange(true);
                } else {
                    this.select2ProductData.trigger("select", { data: { item: this.orderItem.Product, updateTariff: false, id: Guid.newGuid() } });
                }
            }
        }, 300);

        if (this.disableChanges)
            $element.prop("disabled", true);
    }

    private getSearchTypeByQuery(name: string): number {
        let regex = /[^0-9^.]/i;

        if (regex.test(name))
            return this.isVehicle ? ProductSearchType.VehicleQuery : ProductSearchType.ProductQuery;
        return this.isVehicle ? ProductSearchType.VehicleHsCode : ProductSearchType.ProductHsCode;

    }

    public clearProduct(saveName: boolean = false, manualCode: boolean = false): void {
        if (this.disableChanges)
            if (this.disableChanges)
                return;

        let tempName = this.orderItem.Product.Name;
        let tempHs = this.manualHsCode;

        this.orderItem.Product = new Product();

        this.orderItem.DutyList = [];

        if (!manualCode)
            this.manualHsCode = "";

        if (this.isQuickQuote)
            return;

        if (saveName) {
            this.orderItem.Product.Name = tempName;
            this.orderItem.Product.HsCode = tempHs;

            this.select2ProductData.$selection.hide();
            this.isProductNameHidden = false;
            return;
        }

        this.isProductNameHidden = true;

        setTimeout(() => {
            this.select2ProductData.$element.val('');
            this.select2ProductData.$element.trigger('change');
            this.select2ProductData.$selection.show();
        }, 300);
    }

    public handleProductInput(value: any): void {
        if (this.select2ProductData && this.select2ProductData.results && this.select2ProductData.results.lastParams && this.select2ProductData.results.lastParams.term)
            this.select2ProductData.results.lastParams.term = value;
    }

    public initManufacturerSelect(): void {
        let self = this;

        let select = $(`#${self.select2ManufacturerId}`);

        if (this.isQuickQuote)
            this.initStaticManufacturerSelect2(select);
        else
            this.initDynamicManufacturerSelect2(select);

        if (this.disableChanges)
            select.prop("disabled", true);
    }

    private initDynamicManufacturerSelect2(select: any): void {
        let self = this;
        select.select2({
            width: '100%',
            data: [],
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Type or select country of origin',
            ajax: {
                url: this.configService.config.ApiUrl + "/location/search/country",
                datatype: 'json',
                delay: 500,
                headers: {
                    'Authorization': 'Bearer ' + Cookie.get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params: any) {
                    return {
                        country: params.term
                    };
                },
                processResults: function (data: BaseResponse<Country[]>, params: any) {
                    let results: any[] = data.Data.map(function (country) {
                        return {
                            id: country.Code,
                            text: country.Name
                        }
                    });

                    if (self.isQuickQuote) {
                        results = results.filter(x => x.text == "Canada" || x.text == "United States" || x.text == "Mexico")
                    }

                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 2
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            self.orderItem.Manufacturer.Name = selectedData[0].text;
            self.orderItem.Manufacturer.Code = selectedData[0].id;

            self.manufacturer = selectedData[0].id;

            CalculatorHelper.getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:unselect', function (e: any) {
            self.orderItem.Manufacturer = new Country();
            self.manufacturer = '';
            CalculatorHelper.getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        let select2Data = select.data("select2");

        if (!self.orderItem.Manufacturer || !self.orderItem.Manufacturer.Name)
            return;

        setTimeout(() => {
            if (select2Data)
                select2Data.trigger("select", { data: { id: self.orderItem.Manufacturer.Code, text: self.orderItem.Manufacturer.Name } });
        }, 300);
    }

    private initStaticManufacturerSelect2(select: any): void {
        let self = this;

        select.select2({
            width: '100%',
            selectOnClose: true,
            data: [
                {
                    id: "CA",
                    text: "Canada"
                },
                {
                    id: "US",
                    text: "United States"
                },
                {
                    id: "MX",
                    text: "Mexico"
                }
            ],
            allowClear: true,
            placeholder: 'Type or select country of origin',

        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            self.orderItem.Manufacturer.Name = selectedData[0].text;
            self.orderItem.Manufacturer.Code = selectedData[0].id;

            self.manufacturer = selectedData[0].id;

            CalculatorHelper.getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:unselect', function (e: any) {
            self.orderItem.Manufacturer = new Country();
            self.manufacturer = '';
            CalculatorHelper.getTariffs(self.orderItem.Product.Source, self.calculatorHelper.getTariff(self.orderItem, self.order, false, self.taxService.canadianHsCodesAlAndSteel10, self.taxService.canadianHsCodesAlAndSteel25, self.taxService.canadianHsCodesChina0, self.taxService.usaHsCodesChina25), self.orderItem);
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        let select2Data = select.data("select2");

        if (!self.orderItem.Manufacturer || !self.orderItem.Manufacturer.Name)
            return;

        setTimeout(() => {
            if (select2Data)
                select2Data.trigger("select", { data: { id: self.orderItem.Manufacturer.Code } });
        }, 300);
    }

    private handlePdaSelect(selectedData: string[]) {
        this.orderItem.Type = 0;

        this.setPdaTypes(selectedData, this.orderItem);
    }

    private initPdaSelect(): void {
        let self = this;

        let select = $(`#${self.select2PdaId}`);
        let convertedData = this.enumUtil.convertEnumToTuple(self.pdaEnum);

        select.select2({
            width: '100%',
            data: self.generateSelectData(convertedData),
            allowClear: true,
            placeholder: 'Select',
            multiple: 'multiple',
            selectOnClose: true,
            closeOnSelect: false
        }).on('select2:select', function (e: any) {
            self.handlePdaSelect($(this).val());
        }).on('select2:unselect', function (e: any) {
            self.handlePdaSelect($(this).val());
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        if (this.orderItem && this.orderItem.Type && this.orderItem.Type != 0) {
            setTimeout(() => {
                let result: number[] = [];

                for (let pdaType of convertedData) {
                    if ((this.orderItem.Type).hasFlag(parseInt(pdaType.Key.toString()))) {
                        result.push(parseInt(pdaType.Key.toString()));
                    }
                }

                select.val(result).trigger("change");
            }, 300);
        }

        if (this.disableChanges)
            select.prop("disabled", true);
    }

    public changeCurrency(currency: CanadianCurrencyCode): void {
        if (this.select2CurrencyData)
            this.select2CurrencyData.trigger("select", { data: { id: currency.Code } });
    }

    private initCurrencySelect(): void {
        let self = this;

        let $element = $(`#${self.select2CurrencyId}`);

        $element.select2({
            width: '100%',
            allowClear: true,
            placeholder: 'Currency',
            closeOnSelect: true,
            selectOnClose: true
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');

            if (!selectedData || selectedData.length == 0)
                return;

            if (!self.disableChanges) {
                self.orderItem.CanadianCurrencyCode = JSON.parse(JSON.stringify(self.canadianCurrencyCodes.find(x => x.Code.toLowerCase() == selectedData[0].id.toLowerCase())));

                if (self.orderItem.CurrencyId != null)
                    self.orderItem.CanadianCurrencyCode.Id = self.orderItem.CurrencyId.toString();
            }

            if (!self.orderItem.CanadianCurrencyCode) {
                self.select2CurrencyData.trigger("select", { data: { id: "FXUSDCAD" } });
            }
        }).on('select2:unselect', function (e: any) {
            self.orderItem.CanadianCurrencyCode = new CanadianCurrencyCode();
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        this.select2CurrencyData = $element.data("select2");

        setTimeout(() => {
            if (this.orderItem.CanadianCurrencyCode && this.orderItem.CanadianCurrencyCode.Code) {
                this.changeCurrency(this.orderItem.CanadianCurrencyCode);
            }
        }, 300);

        if (this.disableChanges)
            $element.prop("disabled", true);
    }

    private initYearSelect(): void {
        if (!this.isVehicle)
            return;

        let self = this;

        let years = CalculatorHelper.generateYearsArray((new Date().getFullYear()), 1800);

        let result = new Array<any>();

        for (let item of years) {
            result.push({
                id: item,
                text: item
            });
        }

        let $element = $(`#${this.select2ProductId}_year`);

        let select = $element.select2({
            width: '100%',
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Please select year',
            data: result
        }).on('select2:select', function (e: any) {
            self.orderItem.Year = $(this).val();
        }).on('select2:unselect', function (e: any) {
            self.orderItem.Year = null;
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        if (!this.orderItem.Year)
            return;

        if (select.data("select2"))
            select.data("select2").trigger("select", { data: { id: this.orderItem.Year } });

        if (this.disableChanges)
            $element.prop("disabled", true);
    }

    private initGreenLevySelect(): void {
        if (!this.isVehicle)
            return;

        if (!CalculatorHelper.isUsaShipmentFrom(this.order))
            return;

        let self = this;

        this.$greenLevyElement = $(`#${this.select2ProductId}_greenLevy`);

        if (!this.$greenLevyElement || this.$greenLevyElement.length === 0) {
            setTimeout(() => {
                this.initGreenLevySelect();
            }, 150);

            return;
        }

         this.$greenLevySelect = this.$greenLevyElement.select2({
            width: '100%',
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Please select fuel consumption',
            data: this.greenLevyResult
        }).on('select2:select', function (e: any) {
            self.greenLevy.Value = $(this).val();
        }).on('select2:unselect', function (e: any) {
            //self.greenLevy.Value = null;
            //self.orderItem.Taxes.splice(self.orderItem.Taxes.indexOf(self.greenLevy), 1);
            let grlavy = self.orderItem.Taxes.find(x => x.TaxType == TaxType.GreenLevy);

            grlavy.Value = null;
            //self.orderItem.GreenLevy = null;
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });

        let greenLevy = self.orderItem.Taxes.find(x => x.TaxType == TaxType.GreenLevy);

        if (!greenLevy)
            return;

        const select2 = this.$greenLevySelect.data("select2");

        if (!select2) {
            setTimeout(() => {
                this.initGreenLevySelect();
            }, 150);

            return;
        }

        select2.trigger("select", { data: { id: greenLevy.Value } });

        if (this.disableChanges)
            this.$greenLevyElement.prop("disabled", true);
    }

    /**
     * retunr tariff from country list, if manufacturer
     * has been chosen and country list contains this country
     * else return Base Tariff
     * @returns {string}
     * @param dataArray
     * @param orderItem
     */
    private setPdaTypes(dataArray: string[], orderItem: OrderItem): void {

        for (let pdaType of dataArray) {
            if ((orderItem.Type).hasFlag(parseInt(pdaType)))
                continue;

            orderItem.Type |= parseInt(pdaType);
        }
    }

    /**
     * return only duties where measure is not empty
     * @param duties
     * @returns {Duty[]}
     */
    public filterDuties(duties: Duty[]): Duty[] {
        let result: Duty[] = [];

        for (let duty of duties) {
            if ((duty.Measure && duty.Measure.trim()) || duty.DutyType == DutyType.Manual)
                result.push(duty);
        }

        return result;
    }

    public onDutyChange(value: any, mainDuty: Duty): void {
        if (this.order.CalculatorType != CalculatorType.CanadianImport)
            return;

        if (mainDuty.Measure != '%')
            mainDuty.Quantity = value;

        for (let extraDuty of mainDuty.ExtraDuties) {
            if (extraDuty.Measure != '%')
                extraDuty.Quantity = value;
        }
    }

    /**
     * return string label depend on Duty's Measure
     * @param duty
     * @returns {any}
     */
    public getDutyLabel(duty: Duty): string {
        if (duty.DutyType == DutyType.Percent)
            return "Price " + duty.Measure;
        if (duty.Measure == "each")
            return "Quantity";
        if (duty.DutyType == DutyType.Manual)
            return "Manual duty";
        if (new RegExp("(1000|thousand|1,000)").test(duty.Measure)) {
            return "Quantity x1000";
        }

        return duty.Measure;
    }

    public clearData(): void {
        this.isTarifLoading = true;

        if (String.isNullOrEmpty(this.manualHsCode)) {
            let saveName = true;

            if (!this.orderItem.Product.Name)
                saveName = false;

            this.clearProduct(saveName);
        }

    }

    /**
     * handle changing of input filed with HsCode
     * Send request to product search controller
     * to get new product
     * HsCode MUST be fully equal to searched product's HsCode
     */
    public async handleHsChange(force: boolean = false): Promise<void> {
        if (this.orderItem.Product.HsCode == this.manualHsCode && !force) {
            this.isTarifLoading = false;
            return;
        }

        let select = $(`#${this.select2ProductId}`);
        let select2Data = $(select).data('select2');
        let cloned = new Product();

        Object.assign(cloned, this.orderItem.Product);

        if (this.manualHsCode)
            this.orderItem.Product.HsCode = this.manualHsCode;

        //if hsCode is bot fully matched, then remove chosen product
        if (!force && (!this.manualHsCode || !this.manualHsCode.match(/^\d+\.\d+\.(\d+\.\d+|\d{4})$/g))) {
            this.isTarifLoading = false;
            this.orderItem.Product.HsCode = this.manualHsCode;
            return;
        }

        this.isTarifLoading = true;

        this.manualHsCode = this.orderItem.Product.HsCode;

        try {
            this.isTarifLoading = true;
            let response: BaseResponse<SearchResponse<Product>> = await (this.productService.search(new ProductSearchRequest({
                Query: HScodeHelper.addDotAfterLastTwoNumb(this.manualHsCode),
                Source: this.getSearchType(),
                Skip: 0,
                Top: 10,
                RequestType: RequestType.ProductsAndTariffs,
                SearchType: this.isVehicle ? ProductSearchType.VehicleHsCode : ProductSearchType.ProductHsCode,
                CustomerId: this.order.Customer && this.order.Customer.Id && !this.isPublic ? this.order.Customer.Id : null
            })));

            if (!response || !response.Data || response.Data.Items.length == 0 || HScodeHelper.addDotAfterLastTwoNumb(this.manualHsCode) != HScodeHelper.addDotAfterLastTwoNumb(response.Data.Items[0].HsCode)) {
                let saveName = true;

                if (!this.orderItem.Product.Name)
                    saveName = false;

                this.clearProduct(saveName, true);
                return;
            }

            if (!this.productSelect.nativeElement.value) {
                if (this.select2ProductData && this.select2ProductData.results && this.select2ProductData.results.lastParams && this.select2ProductData.results.lastParams.term)
                    this.select2ProductData.results.lastParams.term = "";
            }

            response.Data.Items[0].HsCode = this.manualHsCode;
            select2Data.trigger("select", { data: { item: response.Data.Items[0], updateTariff: true, id: Guid.newGuid() } });
        }
        catch (e) {

        }
        finally {
            this.isTarifLoading = false;
        }
    }

    /**
     * return polarization duty if exists
     * @param duty
     * @returns {Duty}
     */
    private getPolarizationExtraDuty(duty: Duty): Duty {
        for (let dut of duty.ExtraDuties) {
            if (dut.DutyType == DutyType.Degree)
                return dut;
        }

        return new Duty();
    }

    /**
     * return null if no duty with Duty Type Sugar
     * return duty with extra duties when
     * duty with Duty Type Sugar exists
     * @returns {Duty}
     */
    public getSugarDuty(): Duty {
        for (let duty of this.orderItem.DutyList) {
            if (duty.DutyType == DutyType.Sugar) {
                this.polarizationDuty = this.getPolarizationExtraDuty(duty);
                return duty;
            }
        }
        return null;
    }

    /**
     * generate select data from tuple =>
     * convert tuple into object with id and text
     * props
     * @param data
     * @returns {Array}
     */
    public generateSelectData(data: Tuple<number, string>[]): any[] {
        let result = [];

        for (let item of data) {
            result.push({
                id: item.Key,
                text: item.Value
            });
        }

        return result;
    }

    /**
     * return search type for product searching
     * null - when no shipment country selected
     * 0 - when Canada has been selected
     * 1 - when USA has been selected
     * @returns {any}
     */
    private getSearchType(): number {
        if (!this.order.Locations || this.order.Locations.length == 0)
            return null;

        let shipmentTo: Location = this.order.Locations.find(x => x.Type == 2);

        if (shipmentTo.Country.toLowerCase() == 'canada')
            return 0;

        if (shipmentTo.Country.toLowerCase() == 'united states' || shipmentTo.Country.toLowerCase() == 'usa')
            return 1;

        return null;
    }

    public isUsaShipmentTo(): boolean {
        return CalculatorHelper.isUsaShipmentTo(this.order);
    }

    public isCanadaShipmentTo(): boolean {
        return CalculatorHelper.isCanadaShipmentTo(this.order);
    }

    public deleteItem(): void {
        if (this.disableChanges)
            return;

        this.onItemRemoved.emit(this.orderItem);
    }

    public isValid(): boolean {
        return this.accordionForm.valid;
    }

    public isNumber(num: any): boolean {
        return !Number.isNaN(+num);
    }

    public isPass(): boolean {
        if (this.orderItem.Flags)
            return this.orderItem.Flags.hasFlag(OrderItemOptions.IsPassVehicle);
        else
            return false
    }

    public isVehicleCalc(): boolean {
        let result = this.calculatorHelper.isVehicle(this.order);

        if (result)
            this.resetUsaTariffs();

        return result;
    }

    private resetUsaTariffs(): void {
        if (!this.orderItem.Flags)
            return;

        this.isPassVehicle = this.orderItem.Flags.hasFlag(OrderItemOptions.IsPassVehicle);
        this.IsTrucksVal = this.orderItem.Flags.hasFlag(OrderItemOptions.IsTrucks);
    }

    public setPassVehicle(value: boolean): void {
        this.isPassVehicle = value;

        if (value) {
            this.orderItem.Flags |= OrderItemOptions.IsPassVehicle;
        } else {
            this.orderItem.Flags &= ~OrderItemOptions.IsPassVehicle;
        }
    }

    public setIsTrucks(value: boolean): void {
        this.IsTrucksVal = value;

        if (value) {
            this.orderItem.Flags |= OrderItemOptions.IsTrucks;
        } else {
            this.orderItem.Flags &= ~OrderItemOptions.IsTrucks;
        }
    }

    public toggleAES(): void {
        if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(OrderItemOptions.IsAC)) {
            this.orderItem.Flags &= ~OrderItemOptions.IsAC;
        } else {
            this.orderItem.Flags |= OrderItemOptions.IsAC;
        }
    }

    public toggleVehicleParts(): void {
        if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(OrderItemOptions.IsVehicleParts)) {
            this.orderItem.Flags &= ~OrderItemOptions.IsVehicleParts;
        } else {
            this.orderItem.Flags |= OrderItemOptions.IsVehicleParts;
        }
    }

    public toggleIsTrailerOnly(): void {

        if (this.isTrailerOnly) {

            this.$greenLevySelect.val("0").trigger("change");

            this.greenLevy.Value = this.$greenLevySelect.val();
            this.isAC = false;

            if (this.orderItem.Flags != null && this.orderItem.Flags.hasFlag(OrderItemOptions.IsAC)) {
                this.orderItem.Flags &= ~OrderItemOptions.IsAC;
            }
            
            this.orderItem.Flags |= OrderItemOptions.isTrailerOnly;

        } else {
            this.orderItem.Flags &= ~OrderItemOptions.isTrailerOnly;
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/accordions/product-accordion/calculator-accordion.component.ts